// QA check with HW

import {RestApiService} from '../../../rest-api.service';
import {Observable} from "rxjs";
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';
import {
    DisplayCsvImportRequest,
    DisplayRequest,
    DisplayResponse,
} from '../../../../contracts/v0/inventory/display.contracts';
import {ApiV0Inventory} from '../api.v0.inventory';

export class ApiV0Display {
    segment: string;

    constructor(v0: ApiV0Inventory, private rest: RestApiService) {
        this.segment = v0.segment + '/display';
    }

    list(): Observable<BaseCollectionModel<DisplayResponse>> {
        return this.rest.get<BaseCollectionModel<DisplayResponse>>(`${this.segment}/list`, DisplayResponse)
    }

    search(searchModel?: SearchModel): Observable<BaseCollectionModel<DisplayResponse>> {
        return this.rest.post<SearchModel, BaseCollectionModel<DisplayResponse>>(`${this.segment}/search`, DisplayResponse, searchModel)
    }

    detail(guid: string): Observable<DisplayResponse> {
        return this.rest.get(`${this.segment}/details/${guid}`, DisplayResponse)
    }

    create(createRequest: DisplayRequest) {
        return this.rest.post<DisplayRequest, DisplayResponse>(`${this.segment}/create`, DisplayResponse, createRequest)
    }

    update(updateRequest: DisplayRequest) {
        return this.rest.patch<DisplayRequest, DisplayResponse>(`${this.segment}/update`, DisplayResponse, updateRequest)
    }

    delete(guid: string) {
        return this.rest.delete<void>(`${this.segment}/delete/${guid}`)
    }

    importCsvData(data: DisplayCsvImportRequest): Observable<BaseCollectionModel<DisplayResponse>> {
        return this.rest.post<DisplayCsvImportRequest, BaseCollectionModel<DisplayResponse>>(
            `${this.segment}/import/csv`,
            DisplayResponse,
            data
        )
    }

    importExcelData(data: DisplayCsvImportRequest): Observable<BaseCollectionModel<DisplayResponse>> {
        return this.rest.post<DisplayCsvImportRequest, BaseCollectionModel<DisplayResponse>>(
            `${this.segment}/import/excel`,
            DisplayResponse,
            data
        )
    }
}

